import { css } from "@linaria/core";
import { spacings } from "@ui/Theme";
import React, { type PropsWithChildren } from "react";

export const WidgetLegend = ({ children }: PropsWithChildren) => (
  <div className={widgetLegend}>{children}</div>
);

const widgetLegend = css`
  display: flex;
  justify-content: flex-end;
  margin-top: ${spacings.xs};
`;
